// Hide superseded lottery review alerts without deleting historical evidence.
export const isVisibleAdminAlert = alert => alert.type !== "PAYMENT_SLIP_RECEIVED" || ["product", "coupon", "coupon_bundle"].includes(alert.orderKind);
export const adminAlertOrderUrl = alert => alert.orderKind === "product" ? `/product/order/${alert.orderId}`
  : alert.orderKind === "coupon" ? `/coupon/${alert.orderId}`
  : alert.orderKind === "coupon_bundle" ? `/coupon/bundle/${alert.orderId}` : `/orders/${alert.orderId}`;
